import React from 'react';
import classNames from 'classnames';
import './tabs.scss';

const Tabs = ({ activeTab, setActiveTab, tabs = [] }) => {
    if (!tabs.length) {
        return null;
    }

    return (
        <nav className="tabs">
            <ul className="tabs__list">
                {tabs.map((tab) => (
                    <li key={tab.id}>
                        <button
                            type="button"
                            className={classNames({
                                'tabs__item': true,
                                'tabs__item--active': activeTab === tab.id
                            })}
                            onClick={() => setActiveTab(tab.id)}
                        >
                            {tab.label}
                        </button>
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export default Tabs;